var map = {
	"./bitbucket.svg": 77270,
	"./chevron-right.svg": 16279,
	"./circle.svg": 33105,
	"./close.svg": 71449,
	"./code.svg": 1490,
	"./database.svg": 92154,
	"./donut.svg": 89330,
	"./external.svg": 42689,
	"./eye-strikethrough.svg": 13031,
	"./eye.svg": 35489,
	"./git.svg": 57252,
	"./github.svg": 92822,
	"./gitlab.svg": 65327,
	"./graphql.svg": 56284,
	"./menu.svg": 11289,
	"./organization.svg": 52566,
	"./packages.svg": 37218,
	"./password.svg": 77082,
	"./permission-small-cross.svg": 29080,
	"./permission-small-tick.svg": 90985,
	"./placeholder.svg": 11651,
	"./plus-circle.svg": 33622,
	"./plus.svg": 84109,
	"./queues.svg": 80468,
	"./retry.svg": 84640,
	"./twitter.svg": 6476,
	"./unknown-user.svg": 44056,
	"./webhook.svg": 77856
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62294;